import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IThinkAnalyticsGetMoreLikeThisResponse } from '../../../entity/interface/iThinkAnalytics';
import { IThinkAnalyticsRepository } from '../../repositories/interfaces/IThinkAnalyticsRepository';

export interface IGetTAFeedUseCase {
    execute(
        datasource: string,
        apiKey: string,
        token: string,
        queryParams: any
    ): Promise<IThinkAnalyticsGetMoreLikeThisResponse>;
}

export class GetTAFeedUseCase implements IGetTAFeedUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get thinkAnalyticsRepository(): IThinkAnalyticsRepository {
        return container.resolve<IThinkAnalyticsRepository>(DI.REPOSITORIES.IThinkAnalyticsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        datasource: string,
        apiKey: string,
        token: string,
        queryParams: any
    ): Promise<IThinkAnalyticsGetMoreLikeThisResponse> {
        return this.thinkAnalyticsRepository.getTAByUsecaseId(datasource, apiKey, token, queryParams);
    }
}
